export default [
    {
        id : 0,
        title : "white and black",
        content : "Born in France",
        price : 120000,
        //src : "https://codingapple1.github.io/shop/shoes1.jpg"
    },
    {
        id : 1,
        title : "Red Knit",
        content : "Born in Seoul",
        price : 110000,
        //src : "https://codingapple1.github.io/shop/shoes2.jpg"
    },
    {
        id : 2,
        title : "Grey Yordan",
        content : "Born in the States",
        price : 130000,
        //src : "https://codingapple1.github.io/shop/shoes3.jpg"
    }
]